import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface IAIInterface {
  aiSums?: any;
}

const AIEvalEntity: React.FC<IAIInterface> = ({ aiSums }) => {
  const toPercentage = (value: number): string => {
    if (value < 0 || value > 1) {
      throw new Error('Value must be between 0 and 1');
    }
    return `${(value * 100).toFixed()}%`;
  };
  return (
    <div className='screening-ai-container'>
      <div className='screening-ai-row'>
        <div className='screening-ai-label-text'>
          <AutoAwesomeIcon sx={{ marginRight: '10px', color: '#4895ef' }}/>
                AI Evaluation
        </div>
      </div>
      <div className='screening-ai-sums-cont'>
        {aiSums.map((summary: any, i: number) => (
          <div key={i} style={{ marginTop: '15px' }}>
            <div className='screening-ai-sum-group'>
              <div className='screening-ai-sum-header-text'>
                Entity:
              </div>
              <div className='screening-ai-sum-result-text'>
                {summary.entity_name}
              </div>
            </div>
            <div className='screening-ai-sum-group'>
              <div className='screening-ai-sum-header-text'>
                Risk:
              </div>
              <div className='screening-ai-sum-result-text'>
                {summary.risk}
              </div>
            </div>
            <div className='screening-ai-sum-group'>
              <div className='screening-ai-sum-header-text'>
                Best Match:
              </div>
              <div className='screening-ai-sum-result-text'>
                {summary.best_match}
              </div>
            </div>
            <div className='screening-ai-sum-group'>
              <div className='screening-ai-sum-header-text'>
                Match Probability:
              </div>
              <div className='screening-ai-sum-result-text'>
                {typeof summary.match_probability === 'number' ? toPercentage(summary.match_probability) : ''}
              </div>
            </div>
            <div className='screening-ai-sum-group-summary'>
              <div className='screening-ai-sum-header-text' style={{ textDecoration: 'underline' }}>
                Summary
              </div>
              <div className='screening-ai-sum-result-text'>
                {summary.explanation}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


export default AIEvalEntity;
